<template>
  <header>
    <nav class="navbar navbar-expand-md navbar-light">
      <div class="container-fluid">
        <router-link to="/" class="navbar-brand">
          <img
            :src="$t('Header.BrandLogo')"
            alt="Brand Logo"
            class="img-fluid"
          />
        </router-link>

        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbar-Nav"
          @click="toggleCollapse"
          aria-controls="navbar-Nav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        ></button>

        <div
          :class="{ show: isCollapsed }"
          class="collapse navbar-collapse my-2"
          id="navbar-Nav"
        >
          <ul class="navbar-nav mr-auto">
            <!-- <li class="nav-item">
              <router-link to="/Home" class="nav-link text-uppercase">
                {{ $t('Header.HomeTab') }}
              </router-link>
            </li> -->
            <li class="nav-item">
              <router-link
                to="/Home"
                class="nav-link"
                active-class="active"
              >
                {{ $t('Header.HomeTab') }}
              </router-link>
            </li>
            <li class="nav-item">
              <router-link to="/FAQ" class="nav-link">
                {{ $t('Header.SupportTab') }}
              </router-link>
            </li>
          </ul>
        </div>

        <!-- <div class="langtoggle">
          <button @click="changeLanguage('en')" :class="{ active: currentLang === 'en' }">EN</button>
          <button @click="changeLanguage('fr')" :class="{ active: currentLang === 'fr' }">ES</button>
        </div> -->
      </div>
    </nav>
  </header>

  <banner></banner>
</template>

<script>
import banner from '../UI/Banner.vue';
import { useI18n } from 'vue-i18n';
import { ref, watch } from 'vue';
import { loadLocaleMessages } from '@/main.js';

export default {
  components: { banner },
  setup() {
    const { locale } = useI18n();
    const currentLang = ref(locale.value);
    const isCollapsed = ref(false); // ✅ Define state for toggle

    const toggleCollapse = () => {
      isCollapsed.value = !isCollapsed.value;
    };

    const changeLanguage = async (lang) => {
      if (currentLang.value === lang) return;

      await loadLocaleMessages(lang);
      locale.value = lang;
      localStorage.setItem('locale', lang);
      currentLang.value = lang;
    };

    watch(locale, (newLocale) => {
      currentLang.value = newLocale;
    });

    return { currentLang, changeLanguage, isCollapsed, toggleCollapse }; // ✅ Return toggle function
  },
};
</script>
